import { render, staticRenderFns } from "./AdditionalSettings.vue?vue&type=template&id=19f3c24e&scoped=true&"
import script from "./AdditionalSettings.vue?vue&type=script&lang=js&"
export * from "./AdditionalSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalSettings.vue?vue&type=style&index=0&id=19f3c24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f3c24e",
  null
  
)

export default component.exports